// import * as React from 'react';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell, { tableCellClasses } from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import { Button, FormControl, IconButton, InputLabel, Menu, MenuItem, Select, styled, TableFooter, TablePagination } from '@mui/material';
// import TablePaginationActions from '@mui/material/TablePagination/TablePaginationActions';
// import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store';
// import { fetchSellers, selectSellers, updateSellerAccountStatus } from '../../../Redux Toolkit/Seller/sellerSlice';
// import { Coupon } from '../../../types/couponTypes';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import { deleteCoupon } from '../../../Redux Toolkit/Admin/AdminCouponSlice';



// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//     [`&.${tableCellClasses.head}`]: {
//         backgroundColor: theme.palette.common.black,
//         color: theme.palette.common.white,
//     },
//     [`&.${tableCellClasses.body}`]: {
//         fontSize: 14,
//     },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//     '&:nth-of-type(odd)': {
//         backgroundColor: theme.palette.action.hover,
//     },
//     // hide last border
//     '&:last-child td, &:last-child th': {
//         border: 0,
//     },
// }));

// const accountStatuses = [
//     { status: 'ACTIVE', title: 'Active', description: 'Account is active and in good standing' },

//     { status: 'PENDING_VERIFICATION', title: 'Pending Verification', description: 'Account is created but not yet verified' },
//     { status: 'SUSPENDED', title: 'Suspended', description: 'Account is temporarily suspended, possibly due to violations' },
//     { status: 'DEACTIVATED', title: 'Deactivated', description: 'Account is deactivated, user may have chosen to deactivate it' },
//     { status: 'BANNED', title: 'Banned', description: 'Account is permanently banned due to severe violations' },
//     { status: 'CLOSED', title: 'Closed', description: 'Account is permanently closed, possibly at user request' }
// ];


// export default function CouponTable() {
//     const [page, setPage] = React.useState(0);
//     const [status, setStatus] = React.useState(accountStatuses[0].status)
//     const { sellers, adminCoupon } = useAppSelector(store => store)
//     const dispatch = useAppDispatch();

//     const handleDeleteCoupon = (id: number) => {
//         dispatch(deleteCoupon({ id, jwt: localStorage.getItem("jwt") || "" }))
//     }



//     return (
//         <>
//             <div className='pb-5 w-60'>
//                 <FormControl color='primary' fullWidth>
//                     <Select
//                         //   labelId="demo-simple-select-label"
//                         id="demo-simple-select"
//                         value={status}
//                         // onChange={handleAccountStatusChange}
//                         color='primary'
//                         className='text-primary-color'

//                     >
//                         {accountStatuses.map((status) =>
//                             <MenuItem value={status.status}>{status.title}</MenuItem>)}

//                     </Select>
//                 </FormControl>
//             </div>

//             <TableContainer component={Paper}>
//                 <Table sx={{ minWidth: 700 }} aria-label="customized table">
//                     <TableHead>
//                         <TableRow>
//                             <StyledTableCell>Coupon Code</StyledTableCell>
//                             <StyledTableCell >Start Date</StyledTableCell>
//                             <StyledTableCell >End Date</StyledTableCell>
//                             <StyledTableCell >Min Order Value</StyledTableCell>
//                             <StyledTableCell>Discount %</StyledTableCell>
//                             <StyledTableCell>Visibility</StyledTableCell>
//                             <StyledTableCell align="right">Status</StyledTableCell>
//                             <StyledTableCell align="right">Status</StyledTableCell>
//                             <StyledTableCell align="right">Delete</StyledTableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {adminCoupon.coupons?.map((coupon: Coupon) => (
//                             <StyledTableRow key={coupon.id}>
//                                 <StyledTableCell component="th" scope="row">
//                                     {coupon.code}
//                                 </StyledTableCell>
//                                 <StyledTableCell >{coupon.validityStartDate}</StyledTableCell>
//                                 <StyledTableCell >{coupon.validityEndDate}</StyledTableCell>
//                                 <StyledTableCell >{coupon.minimumOrderValue}</StyledTableCell>
//                                 <StyledTableCell>{coupon.discountPercentage}</StyledTableCell>

//                                 <StyledTableCell>
//                                     {coupon.publicCoupon ? "Public" : "Private"}
//                                 </StyledTableCell>

//                                 <StyledTableCell align="right">
//                                     {coupon.active ? "Active" : "Deactive"}
//                                 </StyledTableCell>

//                                 <StyledTableCell align="right">
//                                     <IconButton onClick={() => handleDeleteCoupon(coupon.id)}>
//                                         <DeleteOutlineIcon className='text-red-700 cursor-pointer' />
//                                     </IconButton>

//                                 </StyledTableCell>

//                             </StyledTableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//         </>

//     );
// }



import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { Coupon } from "../../../types/couponTypes";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { deleteCoupon } from "../../../Redux Toolkit/Admin/AdminCouponSlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const couponStatuses = [
  { status: "ACTIVE", title: "Active" },
  { status: "INACTIVE", title: "Inactive" },
];

export default function CouponTable() {
  const [status, setStatus] = React.useState("ACTIVE");
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const [selectedCouponId, setSelectedCouponId] = React.useState<number | null>(
    null
  );

  const { adminCoupon } = useAppSelector((store) => store);
  const dispatch = useAppDispatch();

  const isCouponActiveByDate = (coupon: Coupon) => {
    if (!coupon.validityEndDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expiryDate = new Date(coupon.validityEndDate);
    expiryDate.setHours(0, 0, 0, 0);

    return expiryDate >= today;
  };

  const filteredCoupons = adminCoupon.coupons?.filter((coupon: Coupon) => {
    const activeByDate = isCouponActiveByDate(coupon);

    if (status === "ACTIVE") {
      return activeByDate;
    }

    return !activeByDate;
  });

  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value);
  };

  const handleDeleteClick = (id: number) => {
    setSelectedCouponId(id);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setSelectedCouponId(null);
  };

  const handleConfirmDelete = () => {
    if (selectedCouponId === null) return;

    dispatch(
      deleteCoupon({
        id: selectedCouponId,
        jwt: localStorage.getItem("jwt") || "",
      })
    );

    handleCloseDeleteDialog();
  };

  return (
    <>
      <div className="pb-5 w-60">
        <FormControl color="primary" fullWidth>
          <Select
            id="coupon-status-filter"
            value={status}
            onChange={handleStatusChange}
            color="primary"
            className="text-primary-color"
          >
            {couponStatuses.map((item) => (
              <MenuItem key={item.status} value={item.status}>
                {item.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="coupon table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Coupon Code</StyledTableCell>
              <StyledTableCell>Start Date</StyledTableCell>
              <StyledTableCell>End Date</StyledTableCell>
              <StyledTableCell>Min Order Value</StyledTableCell>
              <StyledTableCell>Discount</StyledTableCell>
              <StyledTableCell align="right">Visibility</StyledTableCell>
              <StyledTableCell align="right">Status</StyledTableCell>
              <StyledTableCell align="right">Delete</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredCoupons?.map((coupon: Coupon) => {
              const activeByDate = isCouponActiveByDate(coupon);

              return (
                <StyledTableRow key={coupon.id}>
                  <StyledTableCell component="th" scope="row">
                    {coupon.code}
                  </StyledTableCell>

                  <StyledTableCell>{coupon.validityStartDate}</StyledTableCell>
                  <StyledTableCell>{coupon.validityEndDate}</StyledTableCell>
                  <StyledTableCell>{coupon.minimumOrderValue}</StyledTableCell>
                  <StyledTableCell>{coupon.discountPercentage}</StyledTableCell>

                  <StyledTableCell align="right">
                    <span
                      className={
                        coupon.publicCoupon
                          ? "font-semibold text-green-700"
                          : "font-semibold text-gray-700"
                      }
                    >
                      {coupon.publicCoupon ? "Public" : "Private"}
                    </span>
                  </StyledTableCell>

                  <StyledTableCell align="right">
                    <span
                      className={
                        activeByDate
                          ? "font-semibold text-green-700"
                          : "font-semibold text-red-700"
                      }
                    >
                      {activeByDate ? "Active" : "Inactive"}
                    </span>
                  </StyledTableCell>

                  <StyledTableCell align="right">
                    <IconButton onClick={() => handleDeleteClick(coupon.id)}>
                      <DeleteOutlineIcon className="text-red-700 cursor-pointer" />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-coupon-dialog-title"
        aria-describedby="delete-coupon-dialog-description"
      >
        <DialogTitle id="delete-coupon-dialog-title">
          Delete Coupon?
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="delete-coupon-dialog-description">
            Are you sure you want to delete this coupon? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}